import { fromJS, Map, List, OrderedSet } from "immutable";
import actionTypes from "./types";

export const initialState = fromJS({
  isLoading: false,
  query: "",
  selectedCategory: "",
  submitError: "",
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MODAL_SELECT_CATEGORY:
      return state.set("selectedCategory", action.selectedCategory);

    case actionTypes.MODAL_UPDATE_QUERY_STRING:
      return state.set("query", action.query);

    case actionTypes.MODAL_START_LOADER:
      return state.set("isLoading", true);

    case actionTypes.MODAL_DEFINITELY_STOP_LOADER:
      return state.set("isLoading", false);

    case actionTypes.MODAL_RESET_STATE:
      return initialState;

    case actionTypes.MODAL_SUBMIT_ERROR:
      return state.set("submitError", action.error);

    default:
      return state;
  }
};
